import { LabelValueUpper } from 'src/app/models/keyvalue';
import { Tenant, Origin, Reason } from 'src/app/models/tenant';
import { BaseProductStateModel } from '../+products/base-product-state.models';


export class TenantStateModel {
    allTenants: Tenant[];

    origins?: TenantOrigins;

    reasons?: TenantReasons;

    dispositions?: TenantDispositions;
}

export interface TenantOrigins {
    tenantId: string;
    values: Origin[];
}

export interface TenantReasons {
    tenantId: string;
    values: Reason[];
}

export interface TenantDispositions {
    tenantId: string;
    values: LabelValueUpper[];
}
